import React, { Component } from 'react';
import cjquery from 'jquery';
import moment from 'moment';
// import FD from '../../views/RestAPI/fetchData';
import language from '../../assets/languages/language';
// import App_data from '../../views/config/App_data';

/* eslint-disable*/
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gitCommitId: '',
    };
  }
  // async componentDidMount() {
  //   await FD.callAPI(App_data.backend_api + '/extras/lastCommitId').then(
  //     async (resp) => {
  //       if (resp.success)
  //         this.setState({
  //           gitCommitId: ` - ${resp.gitCommitId}`,
  //         });
  //     }
  //   );
  // }
  render() {
    function menu_active() {
      cjquery('.nav .nav-item').css({ 'background-color': 'transparent' });
      cjquery('.nav .nav-item').each(function() {
        if (
          cjquery(this)
            .find('a')
            .hasClass('active')
        ) {
          cjquery(this).css({ 'background-color': '#132b40' });
        }
      });
    }

    cjquery('.nav .nav-item a').click(menu_active());

    cjquery(document).ready(function() {
      menu_active();
    });
    const selectedMenu = localStorage.getItem('selectedmenu');
    const { exam_name } = this.props;
    const mainArr = {
      cfa: true,
      cfa_2: true,
      cfa_3: true,
      frm: false,
      soa_p: false,
      soa_fm: false,
    };
    return (
      <footer className='app-footer'>
        {exam_name === 'cfa' || exam_name === 'cfa_2' || exam_name === 'cfa_3' ? (
          <div>{language.LC().FOOTER_MESSAGE}</div>
        ) : selectedMenu === 'frm' ||
          selectedMenu === 'soa_p' ||
          selectedMenu === 'soa_fm' ? null : (
          <div>{language.LC().FOOTER_MESSAGE}</div>
        )}
        {/* {mainArr[exam_name] ? (
          <div>{language.LC().FOOTER_MESSAGE}</div>
        ) : mainArr[selectedMenu] ? null : (
          <div>{language.LC().FOOTER_MESSAGE}</div>
        )} */}
        <div className='d-flex justify-content-between'>
          <span className=''>
            AnalystPrep &copy; {moment().format('YYYY')}
            {this.state.gitCommitId}
          </span>
          <span>
            <a href='https://analystprep.com/privacy/' target='_blank' className='privacy-policy'>
              {language.LC().Privacy_Policy}
            </a>
          </span>
          <span>
            <a href='mailto:support@analystprep.com' target='_top'>
              support@analystprep.com
            </a>
          </span>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js